module.exports = __webpack_public_path__ + "img/home-regular.29843784.svg";